<!-- Nova versão (pills + select) — quando isNewHomePedirDelivery -->
<ng-container *ngIf="isNewHomePedirDelivery">
	<div *ngIf="!stickyMode" #pillsWrapper class="category-pills-wrapper">
		<div class="category-pills">
			<button
				*ngIf="!itemsToHide?.featuredItems"
				type="button"
				class="category-pill"
				[class.category-pill--active]="categoryToScroll === 'featuredItems'"
				(click)="selectCategory('featuredItems')"
			>{{ 'On Sale' | translate }}</button>
			<button
				*ngIf="!itemsToHide?.combos"
				type="button"
				class="category-pill"
				[class.category-pill--active]="categoryToScroll === 'combos'"
				(click)="selectCategory('combos')"
			>{{ comboCategoryName }}</button>
			<button
				*ngIf="!itemsToHide?.pizzas"
				type="button"
				class="category-pill"
				[class.category-pill--active]="categoryToScroll === 'pizzas'"
				(click)="selectCategory('pizzas')"
			>{{ pizzaCategoryName }}</button>
			<ng-container *ngFor="let category of categories; trackBy: trackById">
				<button
					*ngIf="showCategory(category.products)"
					type="button"
					class="category-pill"
					[class.category-pill--active]="categoryToScroll === (category.name + '-' + category.id)"
					(click)="selectCategory(category.name + '-' + category.id)"
				>{{ category.name }}</button>
			</ng-container>
		</div>
	</div>

	<!-- Select (quando a barra está fixa no topo) -->
	<div *ngIf="stickyMode" class="category-select-wrapper">
		<select
			class="category-select"
			[id]="selectId"
			[(ngModel)]="categoryToScroll"
			(change)="onSelectChange($event)"
		>
			<option value="scroll-to-top">↑ {{ 'Back to top' | translate }}</option>
			<option *ngIf="!itemsToHide?.featuredItems" value="featuredItems">{{ 'On Sale' | translate }}</option>
			<option *ngIf="!itemsToHide?.combos" value="combos">{{ truncate(comboCategoryName) }}</option>
			<option *ngIf="!itemsToHide?.pizzas" value="pizzas">{{ truncate(pizzaCategoryName) }}</option>
			<ng-container *ngFor="let category of categories; trackBy: trackById">
				<option *ngIf="showCategory(category.products)" [value]="category.name + '-' + category.id">{{ truncate(category.name) }}</option>
			</ng-container>
		</select>
	</div>
</ng-container>

<!-- Original (master) — RECRIADO sem Ionic: ion-segment → barra horizontal scrollável de
     <button>; ion-label → span. Reaproveita selectCategory() (set categoryToScroll + emit). -->
<ng-container *ngIf="!isNewHomePedirDelivery">
	<div id="categoryNav" class="mp-segment sticky">
		<button type="button" *ngIf="!itemsToHide.featuredItems" id="featuredItems-category" class="mp-segment-button" [class.mp-segment-button--active]="categoryToScroll === 'featuredItems'" (click)="selectCategory('featuredItems'); selectedCategory = 'featuredItems'; categoryToCentralizeInNav = 'featuredItems-category'">
			<span class="mp-segment-label">{{ 'On Sale' | translate }}</span>
		</button>
		<button type="button" *ngIf="!itemsToHide.combos" id="combos-category" class="mp-segment-button" [class.mp-segment-button--active]="categoryToScroll === 'combos'" (click)="selectCategory('combos'); selectedCategory = 'combos'; categoryToCentralizeInNav = 'combos-category'">
			<span class="mp-segment-label">{{ comboCategoryName }}</span>
		</button>
		<button type="button" *ngIf="!itemsToHide.pizzas" id="pizzas-category" class="mp-segment-button" [class.mp-segment-button--active]="categoryToScroll === 'pizzas'" (click)="selectCategory('pizzas'); selectedCategory = 'pizzas'; categoryToCentralizeInNav = 'pizzas-category'">
			<span class="mp-segment-label">{{ pizzaCategoryName }}</span>
		</button>
		<ng-container *ngFor="let category of categories; let i = index; trackBy: trackById">
			<button type="button" *ngIf="showCategory(category.products)" [id]="'general-' + category.id" class="mp-segment-button" [class.mp-segment-button--active]="categoryToScroll === (category.name + '-' + category.id)" (click)="selectCategory(category.name + '-' + category.id); selectedCategory = i; categoryToCentralizeInNav = 'general-' + category.id">
				<span class="mp-segment-label">{{ category.name }}</span>
			</button>
		</ng-container>
	</div>
</ng-container>
